module.exports = __webpack_public_path__ + "img/HeimwehScreenshot24.3009ad6d.png";